import { Stats } from './Stats'

// eslint-disable-next-line import/no-default-export
export default Stats
